var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "cargo-editor",
      staticStyle: {
        display: "flex",
        "flex-direction": "column",
        border: "1px solid #ccc"
      }
    },
    [
      _c("Toolbar", {
        staticStyle: { "border-bottom": "1px solid #ccc" },
        attrs: { editor: _vm.editor, "default-config": _vm.toolbarConfig }
      }),
      _c("Editor", {
        staticStyle: { "flex-grow": "1", "overflow-y": "hidden" },
        attrs: {
          value: _vm.value,
          "default-config": _vm.editorConfig,
          mode: "simple"
        },
        on: { onCreated: _vm.onCreated, input: _vm.onInput }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }